//
// Scroll mode helpers (horizontal desktop vs vertical mobile)
// ================================================================================

export const DESKTOP_HORIZONTAL_MQ = '(min-width: 1024px)';

export function isHorizontalScrollConfigured() {
    return Boolean(document.body?.classList.contains('horizontal-scroll-active'));
}

export function isDesktopHorizontalScrollActive() {
    return isHorizontalScrollConfigured() && window.matchMedia(DESKTOP_HORIZONTAL_MQ).matches;
}

export function isMobileVerticalScrollActive() {
    return isHorizontalScrollConfigured() && !window.matchMedia(DESKTOP_HORIZONTAL_MQ).matches;
}

/** ScrollTrigger con scrub compite con el scroll táctil en móvil vertical */
export function shouldUseScrollTriggerScrub() {
    return !isDesktopHorizontalScrollActive() && !isMobileVerticalScrollActive();
}
